import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import ProgramOverviewCmp, { ProgramOverviewProps } from "./ProgramOverview"

export interface ProgramOverviewWrapperBlokProps {
  blok: ProgramOverviewProps & blokType
}

const ProgramOverview: React.FC<ProgramOverviewWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <ProgramOverviewCmp
      degree={blok.degree}
      location={blok.location}
      specialization={blok.specialization}
      hide_filters={blok.hide_filters}
      hide_degree_filter={blok.hide_degree_filter}
      hide_location_filter={blok.hide_location_filter}
      hide_specialization_filter={blok.hide_specialization_filter}
      cta_option={blok.cta_option}
    />
  </SbEditable>
)

export default ProgramOverview 
